'use client'

import { useRouter } from 'next/navigation'
import { useLocalizedNavigation } from '~/hooks/use-localized-navigation'
import { useViewTransitionNavigate } from '~/hooks/use-view-transition-navigate'

interface NavLink {
  href: string
  titleKey: string
}

interface NavLinkProps {
  link: NavLink
  isScrolled: boolean
  pathname: string
}

export default function NavLink({ link, isScrolled, pathname }: NavLinkProps) {
  const { getLocalizedHref, getFullUrl } = useLocalizedNavigation()
  const router = useRouter()

  const localizedHref = getLocalizedHref(link.href)
  const fullUrl = getFullUrl(link.href)
  const normalize = (str: string) => str.replace(/\/+$/, '').replace(/^\/+/, '')
  const isActive =
    normalize(pathname) === normalize(localizedHref) ||
    normalize(pathname).startsWith(normalize(localizedHref) + '/')
  const handleMouseEnter = () => {
    router.prefetch(fullUrl)
  }
  return (
    <a
      href={fullUrl}
      // onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      style={{ textDecoration: 'none' }}
      className="group relative inline-block"
    >
      <span
        style={{ viewTransitionName: `navlink-${link.href.replace(/\//g, '-')}` }}
        className={`font-body relative !ml-0 inline-block pb-1 font-lexend text-base font-light leading-6 transition-colors duration-300 ${
          isActive
            ? isScrolled
              ? 'text-primary-500'
              : 'text-white'
            : isScrolled
              ? 'text-gray-900 hover:text-primary-500'
              : 'text-white hover:text-primary-100'
        }`}
      >
        {link.titleKey}
        {/* Active border */}
        <span
          className={`absolute bottom-0 left-0 h-[2px] transition-all duration-300 ${
            isActive ? (isScrolled ? 'w-full bg-primary-500' : 'w-full bg-white') : 'w-0'
          }`}
        />
        {/* Hover border */}
        <span
          className={`absolute bottom-0 left-0 h-[2px] transition-all duration-300 group-hover:w-full ${
            !isActive ? (isScrolled ? 'w-0 bg-primary-500' : 'w-0 bg-white') : 'w-0'
          }`}
        />
      </span>
    </a>
  )
}
